import {
  getThemeMode,
  reportDarkPalette
} from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => {
  const isDark = getThemeMode(theme) === "dark";
  return {
  "@global": {
    body: {
      backgroundColor: isDark
        ? reportDarkPalette.bg
        : theme.palette.common.white
      // backgroundImage: "url(" + image + ")"
    }
  },
  footer: {
    color: "#eeeeee",
    textAlign: "left",
    margin: theme.spacing(1),
    fontSize: "10px",
    link: {
      color: "eeeeee"
    }
  },
  subtitle: {
    textAlign: "center",
    margin: theme.spacing(1),
    fontSize: "20px"
  },
  paper: {
    marginTop: theme.spacing(20),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...(isDark && {
      backgroundColor: reportDarkPalette.elevated,
      border: `1px solid ${reportDarkPalette.stroke}`,
      borderRadius: 8,
      padding: theme.spacing(3)
    })
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  logo: {
    objectPosition: "50% 50%",
    width: "116%",
    objectFit: "cover"
  }
};
};

export default appStyle;
